import _pt from "prop-types";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from 'react';
import { DropdownToggle, DropdownContext } from '../Dropdown';
export const OptionsMenuToggle = _ref => {
  let _ref$isPlain = _ref.isPlain,
      isPlain = _ref$isPlain === void 0 ? false : _ref$isPlain,
      _ref$isHovered = _ref.isHovered,
      isHovered = _ref$isHovered === void 0 ? false : _ref$isHovered,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$isFocused = _ref.isFocused,
      isFocused = _ref$isFocused === void 0 ? false : _ref$isFocused,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$parentId = _ref.parentId,
      parentId = _ref$parentId === void 0 ? '' : _ref$parentId,
      _ref$toggleTemplate = _ref.toggleTemplate,
      toggleTemplate = _ref$toggleTemplate === void 0 ? React.createElement(React.Fragment, null) : _ref$toggleTemplate,
      _ref$hideCaret = _ref.hideCaret,
      hideCaret = _ref$hideCaret === void 0 ? false : _ref$hideCaret,
      _ref$isSplitButton = _ref.isSplitButton,
      isSplitButton = _ref$isSplitButton === void 0 ? false : _ref$isSplitButton,
      type = _ref.type,
      _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === void 0 ? 'Options menu' : _ref$ariaLabel,
      props = _objectWithoutProperties(_ref, ["isPlain", "isHovered", "isActive", "isFocused", "isDisabled", "isOpen", "parentId", "toggleTemplate", "hideCaret", "isSplitButton", "type", "aria-label"]);

  return React.createElement(DropdownContext.Consumer, null, ({
    id: contextId
  }) => React.createElement(DropdownToggle, _extends({}, (isPlain || hideCaret) && {
    iconComponent: null
  }, props, {
    isPlain: isPlain,
    isOpen: isOpen,
    isDisabled: isDisabled,
    isHovered: isHovered,
    isActive: isActive,
    isFocused: isFocused,
    id: parentId ? "".concat(parentId, "-toggle") : "".concat(contextId, "-toggle"),
    ariaHasPopup: "listbox",
    "aria-label": ariaLabel,
    "aria-expanded": isOpen
  }, toggleTemplate ? {
    children: toggleTemplate
  } : {})));
};
OptionsMenuToggle.propTypes = {
  parentId: _pt.string,
  onToggle: _pt.func,
  isOpen: _pt.bool,
  isPlain: _pt.bool,
  isFocused: _pt.bool,
  isHovered: _pt.bool,
  isSplitButton: _pt.bool,
  isActive: _pt.bool,
  isDisabled: _pt.bool,
  hideCaret: _pt.bool,
  'aria-label': _pt.string,
  onEnter: _pt.func,
  parentRef: _pt.any,
  toggleTemplate: _pt.node
};